import { render, staticRenderFns } from "./goodsList_ec.vue?vue&type=template&id=d7e80b3e&scoped=true&"
import script from "./goodsList_ec.vue?vue&type=script&lang=js&"
export * from "./goodsList_ec.vue?vue&type=script&lang=js&"
import style0 from "./goodsList_ec.vue?vue&type=style&index=0&id=d7e80b3e&lang=less&scoped=true&"
import style1 from "./goodsList_ec.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e80b3e",
  null
  
)

component.options.__file = "goodsList_ec.vue"
export default component.exports